<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="schoolSummary && schoolProgress">
			<title-bar title="Progreso" :percentage="schoolSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<div class="col between innerRubric">
				<chart :properties="chartProperties" height="40%" width="100%"></chart>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		schoolSummary () {
			if (this.$store.state.school.summary) return this.$store.state.school.summary[0];
			else return this.$store.state.school.summary;
		},
		schoolProgress () {
			return this.$store.state.school.progress;
		},
		chartProperties () {
			return {
				type: 'line',
				data: {
					labels: this.schoolProgress.map((visit) => {
						return `Visita ${visit.number}: ${parseInt(visit.percentage)}%`;
					}),
					datasets: [{
						data: this.schoolProgress.map((visit) => {
							if (visit.coachingCategories.length > 0) return parseInt(visit.percentage);
							else return null;
						}),
						backgroundColor: 'rgba(74, 144, 226, 0.45)',
						borderColor: 'rgba(74, 144, 226, 1)',
						borderWidth: 2,
						dates: this.schoolProgress.map((visit) => {
							return this.getHumanDate(visit.date);
						})
					}]
				},
				options: {
					legend: {
						display: false
					},
					tooltips: {
						backgroundColor: 'rgba(74, 144, 226, 1)',
						borderColor: 'rgba(81, 95, 122, 0.1)',
						borderWidth: 2,
						bodyFontColor: 'white',
						caretSize: 8,
						cornerRadius: 2,
						defaultFontSize: 14,
						displayColors: false,
						enabled: true,
						position: 'nearest',
						titleFontColor: 'white',
						xPadding: 10,
						yPadding: 10,
						callbacks: {
							title: function (tooltipItem, data) {
								return `${data.datasets[0].dates[tooltipItem[0].index]}`;
							},
							label: function (tooltipItem) {
								return `${tooltipItem.yLabel}%`;
							},
							afterLabel: function (tooltipItem, data) {
								if (tooltipItem.index === 0) return '';
								let previousValue = data.datasets[0].data[tooltipItem.index - 1];
								let difference = tooltipItem.yLabel - previousValue;
								let progress = (parseInt(difference) * 100) / parseInt(previousValue);
								return difference <= 0 ? (difference == 0 ? `${-1 * parseInt(progress)}% ` : `- ${-1 * parseInt(progress)}% `) : `+ ${parseInt(progress)}% `;
							}
						}
					},
					scales: {
						xAxes: [{
							gridLines: {
								color: 'rgba(81, 95, 122, 0.2)',
								lineWidth: 1
							}
						}],
						yAxes: [{
							ticks: {
								display: true,
								beginAtZero: true,
								max: 100,
								stepSize: 25
							},
							gridLines: {
								color: 'rgba(81, 95, 122, 0.2)',
								lineWidth: 1
							}
						}]
					}
				}
			};
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		}
	}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/routes/school/Progress.vue